import lightGrayMediumDensityTheme from '@weave-design/theme-data/build/esm/lightGrayMediumDensityTheme';
import lightGrayHighDensityTheme from '@weave-design/theme-data/build/esm/lightGrayHighDensityTheme';
import darkBlueHighDensityTheme from '@weave-design/theme-data/build/esm/darkBlueHighDensityTheme';
import darkBlueMediumDensityTheme from '@weave-design/theme-data/build/esm/darkBlueMediumDensityTheme';
import { INFO360_THEMES } from './theme.types';
export const weaveThemes: Record<INFO360_THEMES, ResolvedTheme> = {
	'HIG Light Theme': lightGrayMediumDensityTheme as ResolvedTheme,
	'HIG Light Theme (High Density)':
		lightGrayHighDensityTheme as ResolvedTheme,
	'HIG Dark Theme': darkBlueMediumDensityTheme as ResolvedTheme,
	'HIG Dark Theme (High Density)': darkBlueHighDensityTheme as ResolvedTheme,
	innovyze: lightGrayMediumDensityTheme as ResolvedTheme,
};

export const weaveLightThemes = {
	'HIG Light Theme': lightGrayMediumDensityTheme as ResolvedTheme,
	'HIG Light Theme (High Density)':
		lightGrayHighDensityTheme as ResolvedTheme,
};

export const weaveDarkThemes = {
	'HIG Dark Theme': darkBlueMediumDensityTheme as ResolvedTheme,
	'HIG Dark Theme (High Density)': darkBlueHighDensityTheme as ResolvedTheme,
};

export const isLightTheme = (theme: INFO360_THEMES) =>
	theme !== INFO360_THEMES.Dark && theme !== INFO360_THEMES.DarkHighDensity;
